import { Grid, LinearProgress } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { PATHS } from 'config';
import { RecruiterV2Service } from 'shared/services';
import RecruiterCandidateProjectsDetailsContent from './components/RecruiterCandidateProjectsDetailsContent';

const RecruiterCandidateProjectsDetailsView = ({
  match,
  history,
  t,
  ...props
}) => {
  const [recruiter, setRecruiter] = useState({});
  const [recruiterProjectCandidate, setRecruiterProjectCandidate] = useState(
    []
  );
  const [fetchDone, setFetchDone] = useState(false);

  const getRecruiterById = id => {
    RecruiterV2Service.getRecruiterV2(id)
      .then(({ data }) => {
        if (!data.email) {
          history.push(PATHS.CANDIDATE.SHOW.replace(':id', data.id));
        }
        setRecruiter(data);
        return getProjectCandidatesOwned(id);
      })
      .then(() => {
        setFetchDone(true);
      })
      .catch(() => {
        //TODO: redirect to 404
        alert(t`recruiter:dataError`);
      });
  };

  const getProjectCandidatesOwned = id => {
    RecruiterV2Service.getRecruiterV2ProjectCandidates(id)
      .then(({ data }) => {
        if (data) {
          setRecruiterProjectCandidate(data);
        }
      })
      .catch(() => {
        //TODO: redirect to 404
        alert(t`recruiter:dataError`);
      });
  };

  useEffect(() => {
    shouldUpdateRecruiter();
  }, []);

  const shouldUpdateRecruiter = () => {
    const { id } = match.params;

    if (!id) {
      getRecruiterById(props.currentUser.id);
    } else {
      getRecruiterById(id);
    }
  };

  const isSelfEdit =
    props.currentUser.id === recruiter.id || props.currentUser.isSuperUser;

  if (!isSelfEdit && fetchDone) {
    history.push(PATHS.DASHBOARD.INDEX);
  }

  return fetchDone ? (
    <RecruiterCandidateProjectsDetailsContent
      isSelfEdit={isSelfEdit}
      recruiterEdited={shouldUpdateRecruiter}
      recruiterProjectCandidate={recruiterProjectCandidate}
      recruiterDetails={recruiter}
      currentUser={props.currentUser}
    />
  ) : (
    <Grid
      container
      style={{ height: 'calc(100vh - 100px)', padding: '50px 0' }}
    >
      <LinearProgress style={{ width: '100%' }} />
    </Grid>
  );
};

const mapStateToProps = store => {
  return {
    currentUser: store.auth.currentUser,
  };
};

export default connect(mapStateToProps)(
  withRouter(withTranslation()(RecruiterCandidateProjectsDetailsView))
);
